import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import NavbarIconsGenericComponent from '../generic-nav-bar/NavbarIconsGenericComponent';
import { startLoadingPlatformHealth } from '../../app/actions/statisticActions';

const ListStatisticsPlatformHealth = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const health = useSelector((state) => state.statistic.platformHealth);

  useEffect(() => {
    dispatch(startLoadingPlatformHealth());
  }, [dispatch]);

  const db = health?.database;
  const tables = health?.tables || [];
  const published = health?.published || [];
  const embeddings = health?.embeddings || [];
  const jobs = health?.embeddingJobs || [];

  return (
    <>
      <NavbarIconsGenericComponent componentName="listStatistics" />
      <div className="container mt-4">
        <h2>{t('semanticSearch.stats.healthTitle', { defaultValue: 'Salud de plataforma' })}</h2>
        <p className="text-muted">{health?.note}</p>
        <div className="row mb-3">
          <div className="col-md-4"><strong>BD:</strong> {db?.name || '—'}</div>
          <div className="col-md-4"><strong>Tamaño:</strong> {db?.size_pretty || '—'}</div>
        </div>
        <h4>Tablas (top 40)</h4>
        <div className="table-responsive mb-4">
          <table className="table table-sm table-striped">
            <thead><tr><th>Tabla</th><th>Filas</th><th>Tamaño</th></tr></thead>
            <tbody>
              {tables.map((row) => (
                <tr key={row.name}><td>{row.name}</td><td>{row.rows}</td><td>{row.size_pretty}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
        <h4>Publicados por módulo</h4>
        <ul>
          {published.map((row) => (
            <li key={row.module_key}>{row.module_key}: {row.published} / {row.total}</li>
          ))}
        </ul>
        <h4>Embeddings</h4>
        <ul>
          {embeddings.map((row) => (
            <li key={row.module_key}>{row.module_key}: {row.count}</li>
          ))}
        </ul>
        <h4>Jobs de vectorización</h4>
        <ul>
          {jobs.map((row) => (
            <li key={row.status}>{row.status}: {row.count}</li>
          ))}
        </ul>
        <p>
          <Link to="/specialist-flow-cmi">
            {t('semanticSearch.stats.openCmi', { defaultValue: 'Abrir panel de control de flujos (CMI)' })}
          </Link>
        </p>
      </div>
    </>
  );
};

export default ListStatisticsPlatformHealth;
